import moment from "moment";

export const LOG_TAG = "[CASES STORE]";
const NUMBER_OF_DAYS_BEFORE_TODAY_TO_SHOW_CASES_REGULAR_USER = 4;
export const date5DaysAgo = moment()
  .subtract(NUMBER_OF_DAYS_BEFORE_TODAY_TO_SHOW_CASES_REGULAR_USER, "days")
  .format("YYYY-MM-DD");
